import React from "react";
import * as PropTypes from "prop-types";

const UIFormSection = ({icon, title, description, extra, children}) => {
	return (
		<div className="form-section">
			{(icon || title || description || extra) && <div className="form-section-header">
				<div className="form-section-header-main">
					{icon && <div className="form-section-header-icon">{icon}</div>}
					<div>
						{title && <p className="form-section-title">{title}</p>}
						{description && <p className="form-section-description">{description}</p>}
					</div>
				</div>
				{extra && <div className="form-section-header-extra">{extra}</div>}
			</div>}
			<div className="form-section-body">{children}</div>
		</div>
	);
};

UIFormSection.propTypes = {
	icon       : PropTypes.node,
	title      : PropTypes.string,
	description: PropTypes.string,
	extra      : PropTypes.node,
	children   : PropTypes.node,
};

UIFormSection.defaultProps = {
	icon       : null,
	title      : "",
	description: "",
	extra      : null,
	children   : null,
};

export default UIFormSection;
